import React, { useState, useEffect } from "react";
import { Form, Row, Col, Card } from "react-bootstrap";
import { toast } from "sonner";
import HeaderFilterV4 from "./growth-report/HeaderFilterV4";
import GrowthReportTableV4 from "./growth-report/GrowthReportTableV4";
import useGrowthReportV4 from "../../../services/cm-growth-report/hooks/useGrowthReportV4";
import SkeletonTable from "./growth-report/SkeletonTable";
import { GrowthReportFilterTypeV4 } from "../../../services/cm-growth-report/schema/GrowthReportFilterSchemaV4";
// import BubbleChartV4 from "./growth-report/BubbleChartV4"; // Import chart baru
import BubbleHighchartsV4 from "./growth-report/BubbleHighchartsV4";

const GrowthContentV4: React.FC = () => {
    const [filters, setFilters] = useState<GrowthReportFilterTypeV4 | null>(null);
    const { data: growthReportData, isFetching: isFetchingGrowthReport } = useGrowthReportV4({
        filter: filters,
    });

    // State untuk menyimpan pilihan perbandingan untuk chart
    const [chartComparison, setChartComparison] = useState<{ from: number; to: number } | null>(null);

    // Set perbandingan default saat data pertama kali dimuat
    useEffect(() => {
        if (growthReportData && growthReportData.length > 0 && growthReportData[0].comparisons.length > 0) {
            const firstComparison = growthReportData[0].comparisons[0];
            setChartComparison({ from: firstComparison.from_period, to: firstComparison.to_period });
        } else {
            setChartComparison(null);
        }
    }, [growthReportData]);

    // Toast notifikasi saat data berhasil di-load
    useEffect(() => {
        if (!isFetchingGrowthReport && growthReportData && growthReportData.length > 0) {
            toast.success('Growth report data loaded successfully.');
        }
    }, [growthReportData, isFetchingGrowthReport]);

    // Opsi untuk dropdown, dibuat dari data yang ada
    const periodOptions = growthReportData?.[0]?.periods.map(p => p.period_index) ?? [];

    return (
        <div className="container-fluid mt-4">
            <HeaderFilterV4 setFilters={setFilters} isLoading={isFetchingGrowthReport} hasData={!!growthReportData} />

            {isFetchingGrowthReport && <SkeletonTable rows={10} columns={7} />}

            {!isFetchingGrowthReport && growthReportData && (
                <>
                    {/* Tabel Laporan */}
                    <div className="mt-4">
                        <h3>Growth Report Details</h3>
                        <GrowthReportTableV4 data={growthReportData} />
                    </div>

                    {/* Kontrol dan Visualisasi Chart */}
                    {chartComparison && (
                        <Card className="mt-4">
                            <Card.Header>
                                <h5>Growth Properties Graph Visualization</h5>
                            </Card.Header>
                            <Card.Body>
                                <Row className="align-items-end mb-3">
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>Compare Period</Form.Label>
                                            <Form.Select
                                                value={chartComparison.from}
                                                onChange={(e) => setChartComparison(prev => ({ ...prev!, from: Number(e.target.value) }))}
                                            >
                                                {periodOptions.map(p => <option key={p} value={p}>Period {p + 1}</option>)}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <Form.Label>With Period</Form.Label>
                                            <Form.Select
                                                value={chartComparison.to}
                                                onChange={(e) => setChartComparison(prev => ({ ...prev!, to: Number(e.target.value) }))}
                                            >
                                                {periodOptions.map(p => <option key={p} value={p}>Period {p + 1}</option>)}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {/* <BubbleChartV4 data={growthReportData} comparison={chartComparison} /> */}
                                <BubbleHighchartsV4 data={growthReportData} comparison={chartComparison} />
                            </Card.Body>
                        </Card>
                    )}
                </>
            )}
        </div>
    );
};

export default GrowthContentV4;